import { 
  axiosSecuredInstance, 
  cancelToken 
} from "configurations/axiosConfig";
import { 
  createHook, 
  createStore, 
  StoreActionApi 
} from "react-sweet-state";
import { 
  ActionResult, 
  SpaceProductSubType as UiSpaceProductSubType 
} from "entities/UIModel";
import { SpaceProductSubType as ApiSpaceProductSubType } from "entities/ApiModel";
import { mapToUiSpaceProductSubTypes } from "utils/data/spaceHelper";
import { ActionResultStatus } from "utils/data/enum";
import { SpaceAgencyProductStateConfiguration } from "entities/ApiModel/Space/SpaceAgencyProductStateConfiguration";
import { CancelTokenSource } from "axios";
import { SelectFieldOption } from "controls/global/select-field/SelectInput";
// import { convertToStringArray } from "utils/shared";
import _ from "lodash"

type State = {
  axiosCancelToken?: CancelTokenSource;
  isLoading: boolean;
  error: string | null,
  spaceProductSubTypes: UiSpaceProductSubType[], // Title Seach - Transaction Types
  tsAgencyConfig: SpaceAgencyProductStateConfiguration | null,
  tsTransactionTypes: Array<SelectFieldOption>;
  tsPropertyTypes: Array<SelectFieldOption>;
};

type Actions = typeof actions;
type StoreApi = StoreActionApi<State>;

const defaultState: State = {
  isLoading: false,
  error: null,
  spaceProductSubTypes: [],
  tsAgencyConfig: null,
  tsTransactionTypes: [],
  tsPropertyTypes: [],
}

const setLoading =
  (isLoading: boolean) =>
    ({ setState }: StoreApi) => {
      setState({ isLoading: isLoading });
    };

const setError =
  (error: string | null) =>
    ({ setState }: StoreApi) => {
      setState({ error });
    };

const setTsTranstionTypes = (spaceProductSubTypes: UiSpaceProductSubType[]) => 
  ({setState}: StoreApi) => {
    if (!spaceProductSubTypes || spaceProductSubTypes.length === 0) {
      return [];
    }   
    
    const mapTSTransactionTypes: SelectFieldOption[] = spaceProductSubTypes.map((s) => {
      const selectFieldOption : SelectFieldOption = {
        text: s.productSubType,
        value: s.productSubType, // s.productSubTypeCode,
        selected: spaceProductSubTypes.length === 1,
      }
      return selectFieldOption;
    })

    setState({ tsTransactionTypes: mapTSTransactionTypes });
}    

const setSpaceProductSubTypes = (data: ApiSpaceProductSubType[]) =>
  ({ dispatch, setState }: StoreApi) => {
    const spaceProductSubTypes = mapToUiSpaceProductSubTypes(data);
    dispatch(setTsTranstionTypes(spaceProductSubTypes));

    setState({
      spaceProductSubTypes: spaceProductSubTypes,
    });
  }

const setTitleSearchAgencyConfig = (data: SpaceAgencyProductStateConfiguration | null) => 
  ({ setState }: StoreApi) => {
    setState({
      tsAgencyConfig: data
    });

    // Set Title Search Property types
    if (
      data &&
      data.products &&
      data.products.length > 0
    ) {
      const productTypes = data?.products
        ?.find((p) => p.name?.toLowerCase() === "titlesearch")
        ?.productTypes;

      if (productTypes && productTypes.length > 0) {
        const propertyTypes2D = productTypes
          ?.filter((pt) => (pt.propertyTypes && pt.propertyTypes.length > 0))
          ?.map((pt) => pt.propertyTypes!);

        if (propertyTypes2D) {
          const propertyTypes1D = _.flatten(propertyTypes2D); 
          const propertyTypesUnique = _.uniq(propertyTypes1D);

          const propertyTypesUniqueSure = propertyTypesUnique?.filter((p) => p && p.length > 0);
          const mapTSPropertyTypes: SelectFieldOption[] = propertyTypesUniqueSure
            ?.map((p) => {
              const selectFieldOption: SelectFieldOption = {
                text: p,
                value: p.toUpperCase(),
                selected: propertyTypesUniqueSure.length === 1,
              };
              return selectFieldOption;
            })          

          setState({
            tsPropertyTypes: _.orderBy(mapTSPropertyTypes, "text", "desc"),
          });          
        }
      }
    }      
  }
  
// const getTitleSeachAencyConfigCachedKey = (
//   companyId: string,
//   state: string
// ) => {
//   return `TitleSearhAgencyConfigCachedKey-${companyId}~${state}`;
// };  


const actions = {
  getTitleSearchTransactionTypes:
    (clientFileId: string) =>
      async ({ dispatch, setState }: StoreApi) => {
        try {
          dispatch(setLoading(true));

          const { data } = await axiosSecuredInstance.get(
            `/Space/TitleSearchTransactionTypes?ClientFileId=${clientFileId}`
          );
          dispatch(setSpaceProductSubTypes(data));
          dispatch(setLoading(false));
          const result: ActionResult = {
            apiResponse: data,
            status: ActionResultStatus.Success,
          };
          return result;
        } catch (error) {
          dispatch(setError(String(error)));
          const result: ActionResult = {
            error: error,
            status: ActionResultStatus.Failed,
          };
          return result;
        }
      },
  getTitleSearchAgencyConfig:
    (clientFileId: string, companyId: string, state: string, enableTitleSearch: boolean = false) =>
      async ({ setState, getState, dispatch }: StoreApi) => {
        try {
          // console.log("getTitleSearchAgencyConfig - companyId:", companyId, " - state:", state);
          if (!companyId || !state) return null;

          // const cachedKey = getTitleSeachAencyConfigCachedKey(companyId, state);
          // const cachedData = sessionStorage.getItem(cachedKey);
          // console.log("cachedKey:", cachedKey);
          // console.log("cachedData:", cachedData);
          // if (cachedData && cachedData !== '""') {
          //   dispatch(
          //     setTitleSearchAgencyConfig(JSON.parse(cachedData)), //, companyId, state)
          //   );
          // } else {
            const token = getState().axiosCancelToken;
            if (token)
              token.cancel("getProductOptions canceled due to new request");

            const newCancelToken = cancelToken.source();
            setState({ axiosCancelToken: newCancelToken });

            var url = `/Space/TitleSearchAgencyConfig?CompanyID=${companyId}&StateAbbr=${state}&ClientFileId=${clientFileId}`;
            // ex: https://localhost:44313/api/Space/TitleSearchAgencyConfig?CompanyID=1-11R3XLF&StateAbbr=MD

            dispatch(setLoading(true));

            const { data } = await axiosSecuredInstance.get<any>(url, {
              cancelToken: newCancelToken.token,
            });

            // if (data) {
            //   sessionStorage.setItem(cachedKey, JSON.stringify(data));
            // }
            dispatch(setTitleSearchAgencyConfig(data));  // , companyId, state));
            dispatch(setLoading(false));
            const result: ActionResult = {
              apiResponse: data,
              status: ActionResultStatus.Success,
            };
            return result;            
          // }
        } catch (error) {
          setState({tsAgencyConfig: null,})          ;
          dispatch(setLoading(false));
          const result: ActionResult = {
            error: error,
            status: ActionResultStatus.Failed,
          };
          return result;          
        }
      },
};

const Store = createStore<State, Actions>({
  initialState: defaultState,
  actions,
  name: "titleSearch",
});

const useSpaceActions = createHook(Store, {
  selector: null,
});

const getSpaceStates = (state: State) =>({
  spaceProductSubTypes: state.spaceProductSubTypes,
  tsTransactionTypes: state.tsTransactionTypes,
  tsPropertyTypes: state.tsPropertyTypes,
})

const useSpaceLookup = createHook(Store,{
  selector: getSpaceStates,
})

const getTitleSearchAgencyConfig = (state: State) => ({
  tsAgencyConfig: state.tsAgencyConfig,
})

const useSpaceAgencyConfig = createHook(Store, {
  selector: getTitleSearchAgencyConfig,
})

export {
  useSpaceActions,
  useSpaceAgencyConfig,
  useSpaceLookup,
}